/** Le schede di «Presenze del personale» (`PeoplePresencePage`), nell'ordine in cui si mostrano. */
export type PresenceTab = 'today' | 'sites' | 'expected';

export const PRESENCE_TABS: readonly PresenceTab[] = ['today', 'sites', 'expected'];
